import React from "react";
import { motion } from "framer-motion";
import { spring } from "../../utils/motion";
export function passwordScore(pw: string): number {
  let score = 0;
  if (pw.length >= 8) score++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw) || pw.length >= 14) score++;
  return score;
}
const labels = ["Too short", "Weak", "Okay", "Good", "Strong"];
const tones = ["bg-bad", "bg-bad", "bg-accent", "bg-good", "bg-good"];
export function PasswordStrength({
  password
}: {
  password: string;
}) {
  const score = password ? passwordScore(password) : 0;
  return <div className="mt-2" aria-live="polite" data-id="element-93" data-mp="30taggbayq27r">
      <div className="grid grid-cols-4 gap-1.5" data-id="element-94" data-mp="35r27z47p3mbf">
        {[0, 1, 2, 3].map(i => <span key={i} className="h-2 overflow-hidden rounded-full border-2 border-line bg-sunken" data-id="element-95" data-mp="35t6cnodf4pcr">
            <motion.span className={`block h-full origin-left ${tones[score]}`} animate={{
          scaleX: i < score ? 1 : 0
        }} transition={spring.snappy} data-id="element-96" data-mp="yyrnmac3qyhk" />
          </span>)}
      </div>
      <p className="mt-1.5 text-xs font-semibold text-ink-2" data-id="element-97" data-mp="2icp5qp5kckjx">
        {password ? labels[score] : "Use 8+ characters with a mix of letters and numbers."}
      </p>
    </div>;
}